/**
 * Fetches the application status from the Hub.
 */
export function fetch() {
  // using thunk middleware, so we return a function
  return (dispatch) => {
    // make the call
    return dispatch({
      type: 'FETCH_STATUS',
      payload: {
        request: {
          method: 'get',
          url: `/admin/status`,
        },
      },
    }).then((response) => {
      return response;
    });
  };
}
